import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import i18n from 'i18n'

import { ApplicationState } from '@/state/root.models'
import { RestApiService } from '@/services'
import {
  setDialogAction,
  setLoadingFullAction,
  setSnackbarAction,
} from '@/state/ui/global/slices/index.slices'

import { removeEmptyProp } from '@/utils'
import ActionTypes from '../constants'
import { ManualBonusPayload, ManualBonusResponse, WalletState } from '../models'

import { WALLET } from './api.routes'
import { getAllWalletThunk } from './get-all.thunk'

const restApiService: RestApiService = Container.get(RestApiService)

export const setManualBonusThunk = createAsyncThunk(
  ActionTypes.SET_MANUAL_BONUS,
  async (payload: ManualBonusPayload, thunkAPI) => {
    try {
      restApiService.requestParams = {
        method: 'POST',
        endpoint: WALLET.SET_BONUS,
        body: payload,
      }

      const { auth, wallet } = thunkAPI.getState() as ApplicationState

      thunkAPI.dispatch(setLoadingFullAction(true))

      const response: ManualBonusResponse = await restApiService.sendData(
        auth.brand.siteId.toString(),
        auth.token,
      )

      thunkAPI.dispatch(setLoadingFullAction(false))

      let message = i18n.t('messages.successfully', {
        item: `${i18n.t('wallet.manualBonus')}`,
        what: i18n.t('added'),
      })

      if (!response.id) {
        message =
          response?.message && typeof response?.message === 'string'
            ? response?.message
            : i18n.t('messages.errorOccurred')
      } else {
        thunkAPI.dispatch(setDialogAction({ open: false }))

        thunkAPI.dispatch(getAllWalletThunk(removeEmptyProp(wallet.filters)))
      }

      thunkAPI.dispatch(
        setSnackbarAction({
          message,
          open: true,
          variant: !response.id ? 'error' : 'success',
        }),
      )

      return response
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))
      return thunkAPI.rejectWithValue({
        message: error,
        status: error,
      })
    }
  },
)

const setManualBonusExtraReducer = (
  builder: ActionReducerMapBuilder<WalletState>,
) => {
  builder.addCase(setManualBonusThunk.fulfilled, (state, { payload }) => {
    state.wasDeleted = true
  })
}

export default setManualBonusExtraReducer
